<template>
  <div class="container mt-5">
    <div class="card text-center floating-card">
      <h4 class="floating-content text-danger">Tabla de seguimiento Desnutrición Crónica</h4>
      <div class="btn-group mb-3">
        <button @click="filterByPeriod(1)" :class="{ 'btn btn-success': isButtonActive(1), 'btn btn-primary': !isButtonActive(1) }">Último mes</button>
        <button @click="filterByPeriod(3)" :class="{ 'btn btn-success': isButtonActive(3), 'btn btn-primary': !isButtonActive(3) }">3 Meses</button>
        <button @click="filterByPeriod(6)" :class="{ 'btn btn-success': isButtonActive(6), 'btn btn-primary': !isButtonActive(6) }">6 Meses</button>
        <button @click="filterByPeriod(9)" :class="{ 'btn btn-success': isButtonActive(9), 'btn btn-primary': !isButtonActive(9) }">9 Meses</button>
        <button @click="filterByPeriod(12)" :class="{ 'btn btn-success': isButtonActive(12), 'btn btn-primary': !isButtonActive(12) }">12 Meses</button>
        <button @click="filterByPeriod(0)" :class="{ 'btn btn-success': isButtonActive(0), 'btn btn-primary': !isButtonActive(0) }">Ver Todos</button>
      </div>
      <div class="table-responsive">
        <table v-if="filteredNiños.length > 0" class="table table-bordered">
          <thead>
            <tr>
              <th>Nombres y Apellidos</th>
              <th>Edad(meses)</th>
              <th>Peso(kg)</th>
              <th>Talla(cm)</th>
              <th>Estado</th> 
              <th>Fecha Registro</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="niño in filteredNiños" :key="niño._id">
              <td>{{ niño.ninoId.nombres }} {{ niño.ninoId.apellidos }}</td>
              <td>{{ niño.edad }}</td>
              <td>{{ niño.peso }}</td>
              <td>{{ niño.longitud }}</td>
              <td :class="{
                'bg-success p-2 text-white bg-opacity-25' : niño.estadoDesnutricion === 'Normal',
                'bg-warning p-2 text-white bg-opacity-75': niño.estadoDesnutricion === 'Sobrepeso',
                'bg-danger p-2 text-white bg-opacity-75': niño.estadoDesnutricion === 'Desnutrición',
                'bg-primary p-2 text-white bg-opacity-25': niño.estadoDesnutricion === 'No evaluado'
              }">
                {{ niño.estadoDesnutricion }}
              </td>
              <td>{{ formatDate(niño.ninoId.fechaRegistro) }}</td>
              <td><a :href="'ninos/' + niño.ninoId._id" class="no-underline"><font-awesome-icon icon="eye" /></a></td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <p class="text-info">No hay registros en este período de tiempo.</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import { BASE_URL } from '../store/config';

export default {
  data() {
    return {
      niños: [],
      errorLoadingNiños: null,
      startDate: null,
      endDate: null,
      activeButton: 0, // Nuevo dato para almacenar el botón activo

    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    totalNiñosConDesnutricion() {
      return this.niños.filter(niño => niño.estadoDesnutricion === 'Desnutrición').length;
    },
    totalPorcentajeNiñosConDesnutricion() {
      const totalNiños = this.niños.length;
      const porcentaje = (this.totalNiñosConDesnutricion / totalNiños) * 100;
      return porcentaje.toFixed(2);
    },
    filteredNiños() {
      if (this.startDate && this.endDate) {
        return this.niños.filter(niño => {
          const registroDate = new Date(niño.ninoId.fechaRegistro);
          return registroDate >= new Date(this.startDate) && registroDate <= new Date(this.endDate);
        });
      } else {
        return this.niños;
      }
    },
  },
  methods: {
    filterByPeriod(months) {
    if (months === 0) {
      // Si seleccionas "Ver Todos", reinicia las fechas a null
      this.startDate = null;
      this.endDate = null;
      this.activeButton = 0; // Agrega esta línea para establecer el botón activo
    } else {
      const currentDate = new Date();
      const startDate = new Date(currentDate);
      startDate.setMonth(startDate.getMonth() - months);

      this.startDate = startDate.toISOString().split('T')[0];
      this.endDate = currentDate.toISOString().split('T')[0];
      this.activeButton = months; // Agrega esta línea para establecer el botón activo
    }
  },
    formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = new Date(dateString).toLocaleDateString(undefined, options);
    return formattedDate;
  },
  loadNiños() {
  axios
    .get(`${BASE_URL}/api/control/reporte`, {
      headers: {
        'x-access-token': this.$store.state.auth.user.accessToken,
      },
    })
    .then(response => {
      const registrosPorNiño = response.data.reduce((acc, niño) => {
        const key = niño.ninoId._id; 
        if (!acc[key] || acc[key].fecha < niño.fecha) {
          acc[key] = niño;
        }
        return acc;
      }, {});

      this.niños = Object.values(registrosPorNiño);
      this.calcularEstadoDesnutricion(); 
    })
    .catch(error => {
      this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
      console.error('Error al cargar niños:', error);
    });
},

    calcularEstadoDesnutricion() {
  // Recorre los registros de cada niño y calcula el estado de desnutrición
  this.niños.forEach(niño => {
    const { edad, peso, longitud } = niño;

    let estadoDesnutricion = '';

    switch (edad) {
  case 1:
    if (peso < 4.3 - 1 || peso > 4.3 + 1 || longitud < 54.6 - 5 || longitud > 54.6 + 5) {
      estadoDesnutricion = peso > 4.3 + 1 ? 'Sobrepeso' : (peso < 4.3 - 1 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 2:
    if (peso < 5.2 - 2 || peso > 5.2 + 2 || longitud < 58.1 - 5 || longitud > 58.1 + 5) {
      estadoDesnutricion = peso > 5.2 + 2 ? 'Sobrepeso' : (peso < 5.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 3:
    if (peso < 6.0 - 2 || peso > 6.0 + 2 || longitud < 61.1 - 5 || longitud > 61.1 + 5) {
      estadoDesnutricion = peso > 6.0 + 2 ? 'Sobrepeso' : (peso < 6.0 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 4:
    if (peso < 6.7 - 2 || peso > 6.7 + 2 || longitud < 63.7 - 5 || longitud > 63.7 + 5) {
      estadoDesnutricion = peso > 6.7 + 2 ? 'Sobrepeso' : (peso < 6.7 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 5:
    if (peso < 7.3 - 2 || peso > 7.3 + 2 || longitud < 65.9 - 5 || longitud > 65.9 + 5) {
      estadoDesnutricion = peso > 7.3 + 2 ? 'Sobrepeso' : (peso < 7.3 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 6:
    if (peso < 7.8 - 2 || peso > 7.8 + 2 || longitud < 67.8 - 5 || longitud > 67.8 + 5) {
      estadoDesnutricion = peso > 7.8 + 2 ? 'Sobrepeso' : (peso < 7.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 7:
    if (peso < 8.3 - 2 || peso > 8.3 + 2 || longitud < 69.5 - 5 || longitud > 69.5 + 5) {
      estadoDesnutricion = peso > 8.3 + 2 ? 'Sobrepeso' : (peso < 8.3 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 8:
    if (peso < 8.8 - 2 || peso > 8.8 + 2 || longitud < 71.0 - 5 || longitud > 71.0 + 5) {
      estadoDesnutricion = peso > 8.8 + 2 ? 'Sobrepeso' : (peso < 8.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 9:
    if (peso < 9.2 - 2 || peso > 9.2 + 2 || longitud < 72.3 - 5 || longitud > 72.3 + 5) {
      estadoDesnutricion = peso > 9.2 + 2 ? 'Sobrepeso' : (peso < 9.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 10:
    if (peso < 9.5 - 2 || peso > 9.5 + 2 || longitud < 73.6 - 5 || longitud > 73.6 + 5) {
      estadoDesnutricion = peso > 9.5 + 2 ? 'Sobrepeso' : (peso < 9.5 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 11:
    if (peso < 9.9 - 2 || peso > 9.9 + 2 || longitud < 74.9 - 5 || longitud > 74.9 + 5) {
      estadoDesnutricion = peso > 9.9 + 2 ? 'Sobrepeso' : (peso < 9.9 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 12:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 13:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 14:
    if (peso < 10.2 - 2 || peso > 10.2 + 2 || longitud < 76.1 - 5 || longitud > 76.1 + 5) {
      estadoDesnutricion = peso > 10.2 + 2 ? 'Sobrepeso' : (peso < 10.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 15:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 16:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 17:
    if (peso < 11.1 - 2 || peso > 11.2 + 2 || longitud < 79 - 5 || longitud > 79+ 5) {
      estadoDesnutricion = peso > 11.2 + 2 ? 'Sobrepeso' : (peso < 11.2 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 18:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 19:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 20:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 21:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 22:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 23:
    if (peso < 11.8 - 2 || peso > 11.8 + 2 || longitud < 82.5 - 5 || longitud > 82.5 + 5) {
      estadoDesnutricion = peso > 11.8 + 2 ? 'Sobrepeso' : (peso < 11.8 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  case 24:
    if (peso < 12.9 - 2 || peso > 12.9 + 2 || longitud < 88 - 5 || longitud > 88 + 5) {
      estadoDesnutricion = peso > 12.9 + 2 ? 'Sobrepeso' : (peso < 12.9 - 2 ? 'Desnutrición' : 'Normal');
    } else {
      estadoDesnutricion = 'Normal';
    }
    break;
  default:
    estadoDesnutricion = 'No evaluado';
    break;
}


    niño.estadoDesnutricion = estadoDesnutricion;
  });
},  
isButtonActive(months) {
      return this.activeButton === months;
    },

  },
  mounted() {
    this.loadNiños();
    this.calcularEstadoDesnutricion();
  },
};
</script>

<style>
.floating-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  transition: box-shadow 0.3s ease-in-out;
}

.floating-content {
  transform: translate3d(0, -5px, 0);
  transition: transform 0.3s ease-in-out;
}

.grafico {
  margin-left: 80px;
}

.no-underline {
    text-decoration: none;
    color: inherit; /* Puedes agregar esto para conservar el color del texto original */
  }

.btn-group button {
  border-right: 2px solid #312f2f; /* Establece el borde derecho para todos los botones */
}

.btn-group button:last-child {
  border-right: none; /* Elimina el borde derecho del último botón para evitar un borde adicional */
}

</style>
